import { TOKEN_SFL, TOKEN_TRI } from '../../lib/name-space';

export const arrSfl = [
  {
    title: 'Private sale1',
    address: '0x69eBA4f8927e1563B08e5d2DcE86803993DaccD6',
    symbol: TOKEN_SFL,
    amount: '1000000000',
  },

  {
    title: 'Private sale2',
    address: '0xCBBD83491461bF5ff98848367736070bFDB3DE75',
    symbol: TOKEN_SFL,
    amount: '1000000000',
  },
  {
    title: 'Team',
    address: '0xC59B2f8FE1EB21a14fEf7e601029c51aC5C903DB',
    symbol: TOKEN_SFL,
    amount: '500000000',
  },
  {
    title: 'Marketing',
    address: '0x76dB4c78106Ff105fC302e3CBb05Da48c6e9B8F4',
    symbol: TOKEN_SFL,
    amount: '819730547',
  },
  {
    title: 'Company',
    address: '0x103aE2868e4ebE054983267387C3b8b83a14F9a2',
    symbol: TOKEN_SFL,
    amount: '2064722013',
  },
  {
    title: 'Inflation Reward',
    address: '0x8dA1eb74c38BDb86309D98280FdA603e1b1d4eaB',
    symbol: TOKEN_SFL,
    amount: '3000000000',
  },
  {
    title: 'Inflation Reward',
    address: '0xB4B21F1fd2d5666F98f468D078032c3C63a7B18f',
    symbol: TOKEN_SFL,
    amount: '3000000000',
  },
];

export const arrTri = [
  {
    title: 'Staking Reward',
    address: '0xe0EF6617452ABDC606beD1BA82e9BC1c76Dfe7a8',
    symbol: TOKEN_TRI,
    amount: '85000000',
  },
  { title: 'Team', address: '0xea140cC4e438B973707ea7A70185aCcD55Aa11b9', symbol: TOKEN_TRI, amount: '5000000' },
  {
    title: 'Marketing',
    address: '0xc216795a8B0c16e9Fa2438962CAa36a888FFd9dF',
    symbol: TOKEN_TRI,
    amount: '10000000',
  },
];
